import React, { Component } from "react";
import { Tabs, Icon } from "antd";

const { TabPane } = Tabs;

const facebookMobileAdStyles = {
    background: "#e9ebee",
    padding: 10,
    width: "100%",
};
const facebookMobileAdStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 3,
    padding: 12,
    position: "relative",
    backgroundRepeat: "no-repeat",
    width: 320,
    //     height: 482,
};
const facebookMobileAdStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
const facebookMobileAdStylesAuthor = {
    color: "#1d2129",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 50,
};
const facebookMobileAdStylesDate = {
    color: "rgb(97, 103, 112)",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16.0833px",
    marginLeft: 50,
};
const facebookMobileAdStylesBody = {
    color: "rgb(29, 33, 41)",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 12,
    marginBottom: 5,
};

const facebookMobileAdStylesLink = {
    textTransform: "uppercase",
    fontSize: 13,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.3,
};
const facebookMobileAdStylesHeadline = {
    fontSize: 13.4,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
};
const facebookMobileAdStylesDescription = {
    fontSize: 11.2,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.3,
};
const facebookMobileAdStylesButton = {
    fontSize: 13.4,
    maxWidth: "calc(100% - 90px)",
    color: "#444950",
    lineHeight: 1.3,
    position: "absolute",
    bottom: 23,
    right: 15,
    border: "1px solid #444950",
    textTransform: "uppercase",
    padding: "3px 5px 3px 5px",
    borderRadius: 4,
    cursor: "pointer",
};
// Inspiring crates delivered every month for kids of all
//                     ages✨. Get 50% off your first month with promo code:
//                     Weekend50

const facebookDesktopAdStyles = {
    background: "#e9ebee",
    padding: 10,
    width: "100%",
};
const facebookDesktopAdStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 3,
    padding: 12,
    position: "relative",
    backgroundRepeat: "no-repeat",
    width: 500,
    // height: 648,
    paddingBottom: 8,
};
const facebookDesktopAdStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
const facebookDesktopAdStylesAuthor = {
    color: "#3c5996",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 48,
    marginTop: 1,
};
const facebookDesktopAdStylesDate = {
    color: "rgb(97, 103, 112)",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16.0833px",
    marginLeft: 47,
    marginTop: 2,
};
const facebookDesktopAdStylesBody = {
    color: "rgb(29, 33, 41)",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 12,
    marginBottom: 5,
};

const facebookDesktopAdStylesLink = {
    textTransform: "uppercase",
    fontSize: 13,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.3,
    marginLeft: -1,
    marginTop: 3,
    letterSpacing: -0.6,
};
const facebookDesktopAdStylesHeadline = {
    fontSize: 15.4,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
    marginTop: 3,
};
const facebookDesktopAdStylesDescription = {
    fontSize: 13,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    marginTop: 3,
};
const facebookDesktopAdStylesButton = {
    fontSize: 12.4,
    maxWidth: "calc(100% - 90px)",
    color: "#4b4f56",
    lineHeight: 1.3,
    position: "absolute",
    bottom: 23,
    right: 10,
    border: "1px solid #bec3c9",
    padding: "5px 10px 5px 10px",
    borderRadius: 2,
    cursor: "pointer",
    fontWeight: "bold",
    letterSpacing: -0.2,
};

/* -- FacebookCarousel -- */
const facebookCarouselMobileAdStyles = {
    background: "#e9ebee",
    padding: 10,
    maxWidth: 330,
    overflowX: "scroll",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "row",
};
const facebookCarouselMobileAdStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 3,
    padding: 12,
    position: "relative",
    backgroundRepeat: "no-repeat",
    width: 230,
    minWidth: 230,
    marginRight: 10,
    //     height: 482,
};
const facebookCarouselMobileAdStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
const facebookCarouselMobileAdStylesAuthor = {
    color: "#1d2129",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 50,
};
const facebookCarouselMobileAdStylesDate = {
    color: "rgb(97, 103, 112)",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16.0833px",
    marginLeft: 50,
};
const facebookCarouselMobileAdStylesBody = {
    color: "rgb(29, 33, 41)",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 12,
    marginBottom: 5,
};
const facebookCarouselMobileAdStylesImage = {
    width: 230,
    height: 230,
    backgroundPosition: "center",
    backgroundSize: "cover",
    // border: "1px solid red",
    marginLeft: -13,
    marginBottom: 13,
};

const facebookCarouselMobileAdStylesHeadline = {
    fontSize: 13.4,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
};
const facebookCarouselMobileAdStylesDescription = {
    fontSize: 11.2,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.3,
    position: "absolute",
    bottom: 10,
};
const facebookCarouselMobileAdStylesButton = {
    fontSize: 12,
    maxWidth: "calc(100% - 90px)",
    color: "#444950",
    lineHeight: 1.3,
    position: "absolute",
    bottom: 23,
    right: 15,
    border: "1px solid #444950",
    padding: "5px 10px",
    borderRadius: 3,
    cursor: "pointer",
};
const facebookCarouselMobileAdStylesFooter = {
    margin: -13,
    background: "#f0f2f5",
    padding: 13,
    height: 70,
    border: "1px solid #dddfe2",
};

/* FacebookCarouselDesktop */

const facebookCarouselDesktopAdStyles = {
    background: "#e9ebee",
    padding: 10,
    maxWidth: 370,
    overflowX: "scroll",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "row",
};
const facebookCarouselDesktopAdStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 3,
    padding: 12,
    position: "relative",
    backgroundRepeat: "no-repeat",
    width: 270,
    minWidth: 270,
    marginRight: 10,
    //     height: 482,
};
const facebookCarouselDesktopAdStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
const facebookCarouselDesktopAdStylesAuthor = {
    color: "#1d2129",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: 1.38,
    marginLeft: 50,
};
const facebookCarouselDesktopAdStylesDate = {
    color: "rgb(97, 103, 112)",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16.0833px",
    marginLeft: 50,
};
const facebookCarouselDesktopAdStylesBody = {
    color: "rgb(29, 33, 41)",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19.3167px",
    overflowWrap: "break-word",
    marginTop: 12,
    marginBottom: 5,
};
const facebookCarouselDesktopAdStylesImage = {
    width: 270,
    height: 270,
    backgroundPosition: "center",
    backgroundSize: "cover",
    // border: "1px solid red",
    marginLeft: -13,
    marginBottom: 13,
};

const facebookCarouselDesktopAdStylesHeadline = {
    fontSize: 13.4,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
};
const facebookCarouselDesktopAdStylesDescription = {
    fontSize: 11.2,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.3,
    position: "absolute",
    bottom: 10,
};
const facebookCarouselDesktopAdStylesButton = {
    fontSize: 10,
    fontWeight: "bold",
    background: "#f5f6f7",
    maxWidth: "calc(100% - 90px)",
    color: "#444950",
    lineHeight: 1.3,
    position: "absolute",
    bottom: 23,
    right: 15,
    border: "1px solid #d5d9dd",
    padding: "5px 10px",
    borderRadius: 3,
    cursor: "pointer",
};
const facebookCarouselDesktopAdStylesFooter = {
    margin: -13,
    background: "#ff",
    padding: 13,
    height: 70,
    border: "1px solid #dddfe2",
};

// Linkedin
const linkedinFooterImage = `url(data:image/png;base64,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)`;

const linkedinTextAdDesktopStyles = {
    background: "#f5f5f5",
    padding: 20,
};
const linkedinTextAdDesktopStylesCard = {
    background: "#ffffff",
    width: 300,
    height: 70,
    position: "relative",
};
const linkedinTextAdDesktopStylesThumbnail = {
    width: 53,
    height: 50,
    top: 10,
    left: 10,
    position: "absolute",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
};
const linkedinTextAdDesktopStylesHeadline = {
    fontSize: 14,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
    position: "absolute",
    top: 15,
    left: 80,
    width: "calc(100% - 80px)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
};
const linkedinTextAdDesktopStylesDescription = {
    fontSize: 12,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.3,
    position: "absolute",
    top: 38,
    left: 80,
    width: "calc(100% - 80px)",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    display: "-webkit-box",
    lineClamp: 2,
    height: 30,
    boxOrient: "vertical",
};

const linkedinSponsoredContentDesktopStyles = {
    background: "#f5f5f5",
    padding: 20,
    // border: "1px solid red",
};
const linkedinSponsoredContentDesktopStylesCard = {
    background: "#ffffff",
    width: "100%",
    position: "relative",
    backgroundImage: linkedinFooterImage,
    backgroundPosition: "bottom 10px left 10px",
    backgroundRepeat: "no-repeat",
};
const linkedinSponsoredContentDesktopStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    top: 10,
    left: 10,
};
const linkedinSponsoredContentDesktopStylesThumbnail = {
    position: "relative",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    marginBottom: 40,
};
const linkedinSponsoredContentDesktopStylesHeadline = {
    fontSize: 14,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
    position: "absolute",
    top: 8,
    left: 65,
    width: "calc(100% - 65px)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
};
const linkedinSponsoredContentDesktopStylesHeader = {
    border: "1px solid transparent",
};
const linkedinSponsoredContentDesktopStylesSubheadline = {
    fontSize: 11,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.2,
    position: "absolute",
    top: 26,
    left: 65,
    width: "calc(100% - 80px)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
};
const linkedinSponsoredContentDesktopStylesDescription = {
    fontSize: 13,
    color: "#202020",
    lineHeight: 1.3,
    position: "relative",
    padding: "0 10px",
};

const linkedinSponsoredContentMobileStyles = {
    background: "#f5f5f5",
    padding: 20,
    // border: "1px solid red",
};
const linkedinSponsoredContentMobileStylesCard = {
    background: "#ffffff",
    width: 375,
    position: "relative",
    backgroundImage: linkedinFooterImage,
    backgroundPosition: "bottom 10px left 10px",
    backgroundRepeat: "no-repeat",
};
const linkedinSponsoredContentMobileStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 40,
    height: 40,
    position: "absolute",
    backgroundColor: "#ddd",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    top: 10,
    left: 10,
};
const linkedinSponsoredContentMobileStylesThumbnail = {
    position: "relative",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    marginBottom: 40,
};
const linkedinSponsoredContentMobileStylesHeadline = {
    fontSize: 14,
    maxWidth: "calc(100% - 90px)",
    fontWeight: "bold",
    color: "black",
    lineHeight: 1.3,
    position: "absolute",
    top: 8,
    left: 65,
    width: "calc(100% - 65px)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
};
const linkedinSponsoredContentMobileStylesHeader = {
    border: "1px solid transparent",
};
const linkedinSponsoredContentMobileStylesSubheadline = {
    fontSize: 11,
    maxWidth: "calc(100% - 90px)",
    color: "#464950",
    lineHeight: 1.2,
    position: "absolute",
    top: 26,
    left: 65,
    width: "calc(100% - 80px)",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
};
const linkedinSponsoredContentMobileStylesDescription = {
    fontSize: 13,
    color: "#202020",
    lineHeight: 1.3,
    position: "relative",
    padding: "0 10px",
};
// ---------------------------------------------------------
// Twitter

const twitterSponsoredContentDesktopStyles = {
    background: "#fff",
    padding: 10,
    maxWidth: 600,
};
const twitterSponsoredContentDesktopStylesCard = {
    background: "#fff",
    border: "1px solid #dddfe2",
    borderRadius: 0,
    padding: "10px 15px",
    position: "relative",
    paddingLeft: 75,
};
const twitterSponsoredContentDesktopStylesHeader = {
    // border: "1px solid red",
};
const twitterSponsoredContentDesktopStylesAvatar = {
    backgroundImage:
        'url("data:image/svg+xml;base64,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")',
    width: 48,
    height: 48,
    position: "absolute",
    backgroundColor: "#ddd",
    borderRadius: "100%",
    backgroundSize: 22,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    left: 15,
    top: 11,
};
const twitterSponsoredContentDesktopStylesNameContainer = {
    // background: "rgba(128,128,255,0.5)",
    height: 20,
};
const twitterSponsoredContentDesktopStylesName = {
    fontSize: "0.97rem",
    color: "#14171a",
    marginTop: -3,
    float: "left",
};
const twitterSponsoredContentDesktopStylesHandle = {
    color: "#667785",
    fontSize: "0.97rem",
    marginLeft: 5,
    float: "left",
    marginTop: -2,
};
const twitterSponsoredContentDesktopStylesDescription = {
    // border: "1px solid red",
    color: "#4d4d4d",
    fontSize: "1.07em",
    lineHeight: 1.3,
    clear: "both",
    marginBottom: 10,
};
const twitterSponsoredContentDesktopStylesThumbnail = {
    position: "relative",
    backgroundSize: "contain",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    marginBottom: "15px",
    marginTop: "8px",
    borderRadius: "15px",
    border: "1px solid #cad7dd",
};
const twitterSponsoredContentDesktopStylesFooter = {
    backgroundImage:
        'url("data:image/png;base64,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")',
    width: 424,
    height: 43,
};

// ---------------------------------------------------------
const FacebookMobilePreview = (props) => {
    let cta_text = "OPEN";
    switch (props.cta_type) {
        case "OPEN_LINK":
            cta_text = "OPEN";
            break;
        case "LIKE_PAGE":
            cta_text = "LIKE";
            break;
        case "SHOP_NOW":
            cta_text = "SHOP NOW";
            break;
        case "PLAY_GAME":
            cta_text = "PLAY GAME";
            break;
        case "INSTALL_APP":
            cta_text = "INSTALL";
            break;
        case "USE_APP":
            cta_text = "USE";
            break;
        case "CALL":
            cta_text = "CALL";
            break;
        case "CALL_ME":
            cta_text = "CALL ME";
            break;
        case "INSTALL_MOBILE_APP":
            cta_text = "INSTALL";
            break;
        case "USE_MOBILE_APP":
            cta_text = "USE";
            break;
        case "MOBILE_DOWNLOAD":
            cta_text = "DOWNLOAD";
            break;
        case "BOOK_TRAVEL":
            cta_text = "BOOK";
            break;
        case "LISTEN_MUSIC":
            cta_text = "LISTEN";
            break;
        case "WATCH_VIDEO":
            cta_text = "WATCH VIDEO";
            break;
        case "LEARN_MORE":
            cta_text = "LEARN MORE";
            break;
        case "SIGN_UP":
            cta_text = "SIGN UP";
            break;
        case "DOWNLOAD":
            cta_text = "DOWNLOAD";
            break;
        case "WATCH_MORE":
            cta_text = "WATCH MORE";
            break;
        case "NO_BUTTON":
            cta_text = "NO_BUTTON";
            break;
        case "VISIT_PAGES_FEED":
            cta_text = "VISIT";
            break;
        case "APPLY_NOW":
            cta_text = "APPLY NOW";
            break;
        case "CONTACT":
            cta_text = "CONTACT";
            break;
        case "BUY_NOW":
            cta_text = "BUY NOW";
            break;
        case "GET_OFFER":
            cta_text = "GET OFFER";
            break;
        case "GET_OFFER_VIEW":
            cta_text = "GET OFFER";
            break;
        case "BUY_TICKETS":
            cta_text = "BUY TICKETS";
            break;
        case "UPDATE_APP":
            cta_text = "UPDATE";
            break;
        case "GET_DIRECTIONS":
            cta_text = "GET DIRECTIONS";
            break;
        case "BUY":
            cta_text = "BUY";
            break;
        case "MESSAGE_PAGE":
            cta_text = "MESSAGE";
            break;
        case "DONATE":
            cta_text = "DONATE";
            break;
        case "SUBSCRIBE":
            cta_text = "SUBSCRIBE";
            break;
        case "SAY_THANKS":
            cta_text = "SAY THANKS";
            break;
        case "SELL_NOW":
            cta_text = "SELL NOW";
            break;
        case "SHARE":
            cta_text = "SHARE";
            break;
        case "DONATE_NOW":
            cta_text = "DONATE NOW";
            break;
        case "GET_QUOTE":
            cta_text = "GET QUOTE";
            break;
        case "CONTACT_US":
            cta_text = "CONTACT US";
            break;
        case "ORDER_NOW":
            cta_text = "ORDER NOW";
            break;
        case "ADD_TO_CART":
            cta_text = "ADD TO CART";
            break;
        case "VIDEO_ANNOTATION":
            cta_text = "ANNOTATION";
            break;
        case "MOMENTS":
            cta_text = "MOMENTS";
            break;
        case "RECORD_NOW":
            cta_text = "RECORD NOW";
            break;
        case "GET_SHOWTIMES":
            cta_text = "GET SHOWTIMES";
            break;
        case "LISTEN_NOW":
            cta_text = "LISTEN NOW";
            break;
        case "WOODHENGE_SUPPORT":
            cta_text = "SUPPORT";
            break;
        case "SOTTO_SUBSCRIBE":
            cta_text = "SUBSCRIBE";
            break;
        case "EVENT_RSVP":
            cta_text = "RSVP";
            break;
        case "WHATSAPP_MESSAGE":
            cta_text = "WHATSAPP MESSAGE";
            break;
        case "FOLLOW_NEWS_STORYLINE":
            cta_text = "FOLLOW";
            break;
        case "SEE_MORE":
            cta_text = "SEE MORE";
            break;
        case "FIND_A_GROUP":
            cta_text = "FIND A GROUP";
            break;
        case "FIND_YOUR_GROUPS":
            cta_text = "FIND GROUPS";
            break;
        default:
            break;
    }

    //console.info("FacebookPreview props", props);
    return (
        <div style={facebookMobileAdStyles}>
            <div style={facebookMobileAdStylesCard}>
                <div style={facebookMobileAdStylesAvatar} />
                <div style={facebookMobileAdStylesAuthor}>
                    National Geographic Website
                </div>
                <div style={facebookMobileAdStylesDate}>Sponsored</div>
                <div style={facebookMobileAdStylesBody}>{props.body}</div>
                <img
                    src={props.image_url}
                    style={{
                        width: "calc(100% + 24px)",
                        borderTop: "1px solid #c4c8ce",
                        // borderBottom: "1px solid #c4c8ce",
                        marginLeft: -12,
                        marginBottom: 7,
                    }}
                    alt=""
                />
                <div style={facebookMobileAdStylesLink}>{props.link_url}</div>
                <div style={facebookMobileAdStylesHeadline}>{props.title}</div>
                <div style={facebookMobileAdStylesDescription}>
                    {props.description}
                </div>
                {props.cta_type !== "NO_BUTTON" ? (
                    <div style={facebookMobileAdStylesButton}>{cta_text}</div>
                ) : null}
                {props.children}
            </div>
        </div>
    );
};
const FacebookDesktopPreview = (props) => {
    let cta_text = "OPEN";
    switch (props.cta_type) {
        case "OPEN_LINK":
            cta_text = "Open";
            break;
        case "LIKE_PAGE":
            cta_text = "Like";
            break;
        case "SHOP_NOW":
            cta_text = "Shop Now";
            break;
        case "PLAY_GAME":
            cta_text = "Play Game";
            break;
        case "INSTALL_APP":
            cta_text = "Install";
            break;
        case "USE_APP":
            cta_text = "Use App";
            break;
        case "CALL":
            cta_text = "Call";
            break;
        case "CALL_ME":
            cta_text = "Call Me";
            break;
        case "INSTALL_MOBILE_APP":
            cta_text = "Install";
            break;
        case "USE_MOBILE_APP":
            cta_text = "Use App";
            break;
        case "MOBILE_DOWNLOAD":
            cta_text = "Download";
            break;
        case "BOOK_TRAVEL":
            cta_text = "Book";
            break;
        case "LISTEN_MUSIC":
            cta_text = "Listen";
            break;
        case "WATCH_VIDEO":
            cta_text = "Watch Video";
            break;
        case "LEARN_MORE":
            cta_text = "Learn More";
            break;
        case "SIGN_UP":
            cta_text = "Sign Up";
            break;
        case "DOWNLOAD":
            cta_text = "Download";
            break;
        case "WATCH_MORE":
            cta_text = "Watch More";
            break;
        case "NO_BUTTON":
            cta_text = "NO_BUTTON";
            break;
        case "VISIT_PAGES_FEED":
            cta_text = "Visit";
            break;
        case "APPLY_NOW":
            cta_text = "Apply Now";
            break;
        case "CONTACT":
            cta_text = "Contact";
            break;
        case "BUY_NOW":
            cta_text = "Buy Now";
            break;
        case "GET_OFFER":
            cta_text = "Get Offer";
            break;
        case "GET_OFFER_VIEW":
            cta_text = "Get Offer";
            break;
        case "BUY_TICKETS":
            cta_text = "Buy Tickets";
            break;
        case "UPDATE_APP":
            cta_text = "Update";
            break;
        case "GET_DIRECTIONS":
            cta_text = "Get Directions";
            break;
        case "BUY":
            cta_text = "Buy";
            break;
        case "MESSAGE_PAGE":
            cta_text = "Message";
            break;
        case "DONATE":
            cta_text = "Donate";
            break;
        case "SUBSCRIBE":
            cta_text = "Subscribe";
            break;
        case "SAY_THANKS":
            cta_text = "Say Thanks";
            break;
        case "SELL_NOW":
            cta_text = "Sell Now";
            break;
        case "SHARE":
            cta_text = "Share";
            break;
        case "DONATE_NOW":
            cta_text = "Donate Now";
            break;
        case "GET_QUOTE":
            cta_text = "Get Quote";
            break;
        case "CONTACT_US":
            cta_text = "Contact Us";
            break;
        case "ORDER_NOW":
            cta_text = "Order Now";
            break;
        case "ADD_TO_CART":
            cta_text = "Add To Cart";
            break;
        case "VIDEO_ANNOTATION":
            cta_text = "Annotation";
            break;
        case "MOMENTS":
            cta_text = "Moments";
            break;
        case "RECORD_NOW":
            cta_text = "Record Now";
            break;
        case "GET_SHOWTIMES":
            cta_text = "Get Showtimes";
            break;
        case "LISTEN_NOW":
            cta_text = "Listen Now";
            break;
        case "WOODHENGE_SUPPORT":
            cta_text = "Support";
            break;
        case "SOTTO_SUBSCRIBE":
            cta_text = "Subscribe";
            break;
        case "EVENT_RSVP":
            cta_text = "RSVP";
            break;
        case "WHATSAPP_MESSAGE":
            cta_text = "WhatsApp Message";
            break;
        case "FOLLOW_NEWS_STORYLINE":
            cta_text = "Follow";
            break;
        case "SEE_MORE":
            cta_text = "See More";
            break;
        case "FIND_A_GROUP":
            cta_text = "Find a Group";
            break;
        case "FIND_YOUR_GROUPS":
            cta_text = "Find Groups";
            break;
        default:
            break;
    }

    //console.info("FacebookPreview props", props);
    return (
        <div style={facebookDesktopAdStyles}>
            <div style={facebookDesktopAdStylesCard}>
                <div style={facebookDesktopAdStylesAvatar} />
                <div style={facebookDesktopAdStylesAuthor}>Development</div>
                <div style={facebookDesktopAdStylesDate}>Sponsored</div>
                <div style={facebookDesktopAdStylesBody}>{props.body}</div>
                <img
                    src={props.image_url}
                    style={{
                        width: "calc(100% + 24px)",
                        borderTop: "1px solid #c4c8ce",
                        // borderBottom: "1px solid #c4c8ce",
                        marginLeft: -12,
                        marginBottom: 7,
                    }}
                    alt=""
                />
                <div style={facebookDesktopAdStylesLink}>{props.link_url}</div>
                <div style={facebookDesktopAdStylesHeadline}>{props.title}</div>
                <div style={facebookDesktopAdStylesDescription}>
                    {props.description}
                </div>
                {props.cta_type !== "NO_BUTTON" ? (
                    <div style={facebookDesktopAdStylesButton}>{cta_text}</div>
                ) : null}
                {props.children}
            </div>
        </div>
    );
};
const FacebookCarouselMobilePreview = (props) => {
    let cta_text = "Learn More";

    const { carousel } = props;

    console.info("FacebookPreview props", props);
    return (
        <div style={facebookCarouselMobileAdStyles}>
            {carousel.map((c, cIndex) => {
                return (
                    <div
                        key={cIndex}
                        style={facebookCarouselMobileAdStylesCard}
                    >
                        <div style={facebookCarouselMobileAdStylesAvatar} />
                        <div style={facebookCarouselMobileAdStylesAuthor}>
                            National Geographic
                        </div>
                        <div style={facebookCarouselMobileAdStylesDate}>
                            Sponsored
                        </div>
                        <div style={facebookCarouselMobileAdStylesBody}></div>
                        <div
                            style={{
                                ...facebookCarouselMobileAdStylesImage,
                                backgroundImage: c.image
                                    ? `url(${c.image.image_data})`
                                    : null,
                            }}
                        ></div>
                        <div style={facebookCarouselMobileAdStylesFooter}>
                            <div style={facebookCarouselMobileAdStylesHeadline}>
                                {c.title}
                            </div>
                            <div
                                style={
                                    facebookCarouselMobileAdStylesDescription
                                }
                            >
                                {c.body}
                            </div>

                            <div style={facebookCarouselMobileAdStylesButton}>
                                {cta_text}
                            </div>

                            {props.children}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
const FacebookCarouselDesktopPreview = (props) => {
    let cta_text = "Learn More";

    const { carousel } = props;

    //console.info("FacebookPreview props", props);
    return (
        <div style={facebookCarouselDesktopAdStyles}>
            {carousel.map((c, cIndex) => {
                return (
                    <div
                        key={cIndex}
                        style={facebookCarouselDesktopAdStylesCard}
                    >
                        <div style={facebookCarouselDesktopAdStylesAvatar} />
                        <div style={facebookCarouselDesktopAdStylesAuthor}>
                            National Geographic
                        </div>
                        <div style={facebookCarouselDesktopAdStylesDate}>
                            Sponsored
                        </div>
                        <div style={facebookCarouselDesktopAdStylesBody}></div>
                        <div
                            style={{
                                ...facebookCarouselDesktopAdStylesImage,
                                backgroundImage: c.image?`url(${c.image.image_data})`:null,
                            }}
                        ></div>
                        <div style={facebookCarouselDesktopAdStylesFooter}>
                            <div
                                style={facebookCarouselDesktopAdStylesHeadline}
                            >
                                {c.title}
                            </div>
                            <div
                                style={
                                    facebookCarouselDesktopAdStylesDescription
                                }
                            >
                                {c.body}
                            </div>

                            <div style={facebookCarouselDesktopAdStylesButton}>
                                {cta_text}
                            </div>

                            {props.children}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
// Linkedin Ads
const LinkedinTextAdDesktopPreview = (props) => {
    const backgroundImage = { backgroundImage: `url(${props.image_url})` };
    //console.info("FacebookPreview props", props);
    return (
        <div style={linkedinTextAdDesktopStyles}>
            <div style={linkedinTextAdDesktopStylesCard}>
                <div
                    style={{
                        ...linkedinTextAdDesktopStylesThumbnail,
                        ...backgroundImage,
                    }}
                />

                <div style={linkedinTextAdDesktopStylesHeadline}>
                    {props.title}
                </div>
                <div style={linkedinTextAdDesktopStylesDescription}>
                    {props.description}
                </div>
            </div>
        </div>
    );
};
const LinkedinSponsoredContentDesktopPreview = (props) => {
    //console.info("FacebookPreview props", props);
    return (
        <div style={linkedinSponsoredContentDesktopStyles}>
            <div style={linkedinSponsoredContentDesktopStylesCard}>
                <div style={linkedinSponsoredContentDesktopStylesHeader}>
                    <div style={linkedinSponsoredContentDesktopStylesAvatar} />

                    <div style={linkedinSponsoredContentDesktopStylesHeadline}>
                        John Smith
                    </div>
                    <div
                        style={linkedinSponsoredContentDesktopStylesSubheadline}
                    >
                        56 Followers
                        <br />
                        Promoted
                    </div>
                </div>

                <div style={linkedinSponsoredContentDesktopStylesDescription}>
                    <p style={{ marginTop: 60 }}>{props.description}</p>
                </div>
                <img
                    alt={"Ad Preview"}
                    src={props.image_url}
                    style={{
                        ...linkedinSponsoredContentDesktopStylesThumbnail,
                    }}
                />
            </div>
        </div>
    );
};
const LinkedinSponsoredContentMobilePreview = (props) => {
    //console.info("FacebookPreview props", props);
    return (
        <div style={linkedinSponsoredContentMobileStyles}>
            <div style={linkedinSponsoredContentMobileStylesCard}>
                <div style={linkedinSponsoredContentMobileStylesHeader}>
                    <div style={linkedinSponsoredContentMobileStylesAvatar} />

                    <div style={linkedinSponsoredContentMobileStylesHeadline}>
                        John Smith
                    </div>
                    <div
                        style={linkedinSponsoredContentMobileStylesSubheadline}
                    >
                        56 Followers
                        <br />
                        Promoted
                    </div>
                </div>

                <div style={linkedinSponsoredContentMobileStylesDescription}>
                    <p style={{ marginTop: 60 }}>{props.description}</p>
                </div>
                <img
                    alt={"Ad Preview"}
                    src={props.image_url}
                    style={{
                        ...linkedinSponsoredContentMobileStylesThumbnail,
                    }}
                />
            </div>
        </div>
    );
};
// Twitter Ads
const TwitterSponsoredContentDesktopPreview = (props) => {
    //console.info("FacebookPreview props", props);
    return (
        <div style={twitterSponsoredContentDesktopStyles}>
            <div style={twitterSponsoredContentDesktopStylesCard}>
                <div style={twitterSponsoredContentDesktopStylesHeader}>
                    <div style={twitterSponsoredContentDesktopStylesAvatar} />
                    <div
                        style={
                            twitterSponsoredContentDesktopStylesNameContainer
                        }
                    >
                        <div style={twitterSponsoredContentDesktopStylesName}>
                            Name of account
                        </div>
                        <div style={twitterSponsoredContentDesktopStylesHandle}>
                            @handle
                        </div>
                    </div>
                </div>

                <div style={twitterSponsoredContentDesktopStylesDescription}>
                    {props.description}
                </div>
                {props.image_url ? (
                    <img
                        alt={"Ad Preview"}
                        src={props.image_url}
                        style={{
                            ...twitterSponsoredContentDesktopStylesThumbnail,
                        }}
                    />
                ) : null}

                <div style={twitterSponsoredContentDesktopStylesFooter} />
            </div>
        </div>
    );
};
// TODO: Finish mobile view of Twitter sponsored ad (if different than the desktop version)
// const TwitterSponsoredContentMobilePreview = (props) => {
//     //console.info("TwitterSponsoredContentMobilePreview props", props);
//     return <div></div>;
// };

class AdPreview extends Component {
    state = {
        size: "small",
    };

    // constructor(props) {
    //     super(props);
    // }

    handleSizeChange = (e) => {
        this.setState({ size: e.target.value });
    };
    render() {
        let content = "";
        //console.info("AdPreview this.props", this.props);
        content = (
            <div style={{ width: "100%" }}>
                <Tabs
                    defaultActiveKey="1"
                    style={{ marginBottom: 30 }}
                    animated={false}
                >
                    {this.props.networks &&
                    this.props.networks.facebook === true ? (
                        <TabPane
                            tab={
                                <span>
                                    <Icon
                                        type="facebook"
                                        theme="filled"
                                        style={{
                                            color: this.props.store.getTagColorForType(
                                                "facebook"
                                            ),
                                        }}
                                    />
                                    Facebook
                                </span>
                            }
                            key="1"
                        >
                            {this.props.type &&
                            this.props.type === "singleimagead" ? (
                                <FacebookMobilePreview
                                    {...this.props}
                                ></FacebookMobilePreview>
                            ) : null}
                            {this.props.type &&
                            this.props.type === "carouselad" ? (
                                <FacebookCarouselMobilePreview
                                    {...this.props}
                                ></FacebookCarouselMobilePreview>
                            ) : null}
                            {this.props.type &&
                            this.props.type === "singleimagead" ? (
                                <FacebookDesktopPreview
                                    {...this.props}
                                ></FacebookDesktopPreview>
                            ) : null}
                            {this.props.type &&
                            this.props.type === "carouselad" ? (
                                <FacebookCarouselDesktopPreview
                                    {...this.props}
                                ></FacebookCarouselDesktopPreview>
                            ) : null}
                        </TabPane>
                    ) : null}

                    {this.props.networks &&
                    this.props.networks.linkedin === true ? (
                        <TabPane
                            tab={
                                <span>
                                    <Icon
                                        type="linkedin"
                                        theme="filled"
                                        style={{
                                            color: this.props.store.getTagColorForType(
                                                "linkedin"
                                            ),
                                        }}
                                    />
                                    Linkedin
                                </span>
                            }
                            key="2"
                        >
                            {this.props.linkedin_newad_type &&
                            this.props.linkedin_newad_type === "TEXT_AD" ? (
                                <LinkedinTextAdDesktopPreview
                                    {...this.props}
                                ></LinkedinTextAdDesktopPreview>
                            ) : null}

                            {this.props.linkedin_newad_type &&
                            this.props.linkedin_newad_type ===
                                "SPONSORED_UPDATES" ? (
                                <LinkedinSponsoredContentDesktopPreview
                                    {...this.props}
                                ></LinkedinSponsoredContentDesktopPreview>
                            ) : null}

                            {this.props.linkedin_newad_type &&
                            this.props.linkedin_newad_type ===
                                "SPONSORED_UPDATES" ? (
                                <LinkedinSponsoredContentMobilePreview
                                    {...this.props}
                                ></LinkedinSponsoredContentMobilePreview>
                            ) : null}
                        </TabPane>
                    ) : null}
                    {this.props.networks &&
                    this.props.networks.twitter === true ? (
                        <TabPane
                            tab={
                                <span>
                                    <Icon
                                        type="twitter"
                                        style={{
                                            color: this.props.store.getTagColorForType(
                                                "twitter"
                                            ),
                                        }}
                                    />
                                    Twitter
                                </span>
                            }
                            key="3"
                        >
                            <TwitterSponsoredContentDesktopPreview
                                {...this.props}
                            ></TwitterSponsoredContentDesktopPreview>
                            {/* 
                            <TwitterSponsoredContentMobilePreview
                                {...this.props}
                            ></TwitterSponsoredContentMobilePreview> */}
                        </TabPane>
                    ) : null}
                </Tabs>
            </div>
        );

        return (
            <div style={this.props.style ? this.props.style : null}>
                {content}
            </div>
        );
    }
}

export default AdPreview;
